import ContentPanel from "components/contentPanel/ContentPanel";
import { memo } from "react";
import styled from "styled-components";

const Content = styled.article`
  &:nth-child(even) {
    background-color: #f8f9fb;
  }

  strong {
    font-weight: 500;
    font-size: 1.2rem;
    display: block;
    margin-bottom: 0;
    margin-top: 0;
    padding: 20px 25px 15px;
  }

  span {
    display: block;
    border-bottom: solid 1px #e8e8ef;
    padding: 0 25px 20px;
  }
`;

const Contents = styled.div`
  border-bottom: none;
`;

interface DomainPanelProps {
  title: string;
  details: Content[];
}

export interface Content {
  title: string;
  description: string;
}

const DomainPanel = (props: DomainPanelProps) => {
  const { title, details } = props;

  return (
    <>
      <ContentPanel title={title}>
        <Contents>
          {details.map((d, index) => (
            <Content key={`${d.title}-${index}`}>
              <strong>{d.title}</strong>
              <span>{d.description}</span>
            </Content>
          ))}
        </Contents>
      </ContentPanel>
    </>
  );
};

export default memo(DomainPanel);
